module.exports = "/settings/components/editDayPart/editDayPart-fac1bc.html";